<app-spinner [isLoading]="isLoading"></app-spinner>
<p-toast life="8000"></p-toast>

<p-dialog header="Parcel Image Details" [(visible)]="displayDialog" [modal]="true" (onHide)="resetModalState()"
  [closable]="true" [style]="{width: '80vw'}">
  @if (displayDialog && selectedRow && !recordNotFound) {
    @if (selectedRow) {
      <app-parcel-detail [parcel]="selectedRow" (notFound)="handleRecordNotFound()"
      (apiSuccess)="onApiSuccessFromModal($event)" (close)="displayDialog = false"></app-parcel-detail>
    }
  } @else {
    <p class="text-danger"> Record Not found</p>
  }

</p-dialog>
<app-dashboard-filters [cameraList]=cameraList [itemCodes]=itemCodes [filterOptions]=filterOptions [userLists]=users
  (filterAppliedEvent)="receiveFilterApplied($event)" (clearFilterEvent)="receiveClearFilter()">
</app-dashboard-filters>
<div class="grid">
  <div class="col-12">
    <p-table showGridlines size="small" class="fullscreen-table" [value]="reprocessingItems"
      [(selection)]="selectedItems" rowSelection="true" dataKey="itemId" [paginator]="true" [rows]="25"
      (onPage)="onPageChange($event)" [tableStyle]="{ 'min-width': '20rem' }" [showCurrentPageReport]="true"
      currentPageReportTemplate="{first} - {last} of {totalRecords}"
      [rowsPerPageOptions]="[25, 50, 100,200,500,1000,5000]" (selectionChange)="checkSelection();"
      [paginatorPosition]='"top"' [paginatorStyleClass]="'parcel-list-table-paginator'">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 0%;">
            <p-tableHeaderCheckbox />
          </th>
          <th style="width: 15%" pSortableColumn="timestamp">
            <div class="flex justify-content-between items-center w-full">
              <span>Date</span>
              <p-sortIcon field="timestamp" />
            </div>
          </th>
          <th style="width: 15%">Time</th>
          <th style="width: 20%">Parcel Id</th>
          <th style="width: 35%">Actions</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-parcel>
        <tr [pSelectableRow]="parcel">
          <td>
            <p-tableCheckbox [value]="parcel" />
          </td>
          <td>{{ parcel.timestamp | date: 'dd-MM-yyyy'}}</td>
          <td>{{ parcel.timestamp | date:'HH:mm:ss':'UTC'}}</td>
          <td>
            <a href="javascript:void(0)" class="text-to-button" (click)="onParcelClick($event, parcel)">
              {{ parcel.itemId }}
            </a>
          </td>
          <td>
            <p-select [disabled]="selectedItems.length > 0" [style]="{'width':'100%'}" [options]="users"
              [(ngModel)]="parcel.selectedUser" placeholder="Assignee" [filter]="true" appendTo="body"
              [editable]="true" (onChange)="onParcelAssigneeSelection(parcel);singleSelections = true"
              [showClear]="true" />
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td colspan="5" style="text-align: center;"> <strong>No records found.</strong></td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  @if (selectedItems.length > 0 || itemsFromSingleSelections.length > 0) {
    <div class="floating-action-bar">
      <div class="flex justify-content-end align-items-center gap-3">
        @if (selectedItems.length > 0) {
            <p-select [style]="{'width':'175px'}" [options]="BulkUsersList"
            [(ngModel)]="bulkUpdateUserId" placeholder="Assignee" [filter]="true" appendTo="body"
            [showClear]="(bulkUpdateUserId != '')?true:false" />
        }
        <p-button label="Assign" (click)="onAssign()" severity="success" type="button"
          [pTooltip]="getToolTipFormattedText()" tooltipPosition="top"
          [disabled]="selectedItems.length > 0 ? !bulkUpdateUserId : false" />
        </div>
      </div>
    }
    <p-confirmDialog [closable]="enableClose">
    </p-confirmDialog>

    <p-toast key="actionToast" (onClose)="closeToast()">
      <ng-template let-message pTemplate="message">
        <div class="custom-toast">

          <div class="toast-content">
            <div>
              <strong>{{ message.summary }}</strong>
              <div>{{ message.detail }}</div>
            </div>

            <button
              pButton
              type="button"
              class="p-button-text p-button-sm undo-btn"
              (click)="onUndo()">
              Undo (<span class="timer-txt"> {{timeLeft}}s</span>)
            </button>
          </div>

        </div>
      </ng-template>
    </p-toast>